import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";
/**
 * 我的钱包
 */
export function moneyData(data){//获取钱包金额信息
	return request.post(config.baseApi+"/business/basinessmoneyinfo",data)
}
export function paymentCode(data){//获取支付二维码
	return request.post(config.baseApi+"/business/paymentcode",data)
}
export function checkRecharge(data){//查询充值情况
	return request.post(config.baseApi+"/business/basinessrecharge",data)
}
export function tixianInfo(data){//获取提现信息
	return request.post(config.baseApi+"/business/basinesstixianinfo",data)
}
export function tixianData(data){//发起提现
	return request.post(config.baseApi+"/business/basinesstixian",data)
}
export function walletData(data){//钱包记录流水
	return request.post(config.baseApi+"/business/basinessjineflow",data)
}

/**
 * 上架策略
 */
export function celveData(data){//获取上架策略数据
	return request.post(config.baseApi+"/business/strategylist",data)
}
export function saveCelve(data){//保存上架策略
	return request.post(config.baseApi+"/business/editstrategy",data)
}

/**
 * 个人设置
 */
export function setAvatar(data){//更换头像
	return request.post(config.baseApi+"/business/basinessediticon",data)
}
export function changePhone(data){//换绑手机
	return request.post(config.baseApi+"/business/basinesseditmobile",data)
}
export function changePwd(data){//更改密码
	return request.post(config.baseApi+"/business/basinesseditpassword",data)
}
export function changeRemind(data){//接收公众号提醒
	return request.post(config.baseApi+"/business/basinesssetwxremind",data)
}
export function changeDecrypt(data){//开启自动解密
	return request.post(config.baseApi+"/business/basinesssetdecrypt",data)
}
export function decryptLog(data){//解密日志
	return request.get(config.baseApi+"/business/User/decryptLog",data)
}
export function changeAutoPrint(data){//开启自动打单
	return request.post(config.baseApi+"/business/basinesssetautoprintorder",data)
}
export function changeWx(data){//换绑微信
	return request.post(config.baseApi+"/business/basinesschangewx",data)
}


/**
 * 推广中心
 */
export function extendUrl(data){//获取推广中心链接
	return request.post(config.baseApi+"/business/basinesstgurl",data)
}
export function extendList(data){//获取推广中心合作列表
	return request.post(config.baseApi+"/business/basinesstglist",data)
}

/**
 * 我的抖店
 */
export function ddShopList(data){//获取我的抖店列表
	return request.get(config.baseApi+"/business/DdShop/list",data)
}
export function ddShopDel(data){//删除抖店
	return request.post(config.baseApi+"/business/DdShop/del",data)
}
export function resetResourceState(data){//重置素材容量不足状态
	return request.post(config.baseApi+"/business/DdShop/reset_resource_state",data)
}

/**
 * 我的商品
 */
export function goodsFilterData(data){//获取商品筛选数据
	return request.get(config.baseApi+"/business/DdProduct/filter_data",data)
}
export function goodsList(data){//获取商品列表
	return request.get(config.baseApi+"/business/DdProduct/list",data)
}
export function batOnSale(data){//批量上架商品
	return request.post(config.baseApi+"/business/DdProduct/bat_on_sale",data)
}
export function batOffSale(data){//批量下架商品
	return request.post(config.baseApi+"/business/DdProduct/bat_off_sale",data)
}
export function batProductEdit(data){//商品批量改价
	return request.post(config.baseApi+"/business/DdProduct/bat_product_edit",data)
}
export function productDel(data){//删除商品
	return request.post(config.baseApi+"/business/DdProduct/del",data)
}
export function productBatDel(data){//批量删除商品
	return request.post(config.baseApi+"/business/DdProduct/bat_del",data)
}
export function deliverEnums(data){//获取发货时效
	return request.get(config.baseApi+"/business/DdProduct/deliver_enums",data)
}
export function batEditDeliveryDay(data){//批量改发货时效
	return request.post(config.baseApi+"/business/DdProduct/bat_edit_delivery_day",data)
}

/**
 * 商品关联
 */
export function goodsRelativeInfoData(data){//获取关联商品信息
	return request.get(config.baseApi+"/business/DdProduct/relativeInfo",data)
}
export function goodsConfigData(data){//获取关联商品规格
	return request.get(config.baseApi+"/business/DdProduct/productSku",data)
}
export function submitRelative(data){//获取关联商品规格
	return request.post(config.baseApi+"/business/DdProduct/subSkuRelative",data)
}
export function submitPddSkuRelative(data){//提交pdd商品sku关联
	return request.post(config.baseApi+"/business/DdProduct/subPddSkuRelative",data)
}
export function similarGoodsData(data){//搜索同款商品
	return request.get(config.baseApi+"/business/DdProduct/searchProduct",data)
}
export function syncProduct(data){//一键同步商品
	return request.post(config.baseApi+"/business/DdProduct/syncProduct",data)
}
export function alibabaRelativeInfoData(data){//获取关联1688商品sku
	return request.get(config.baseApi+"/business/DdProduct/alibabaRelativeInfo",data)
}
export function alibabaSkuInfoData(data){//获取关联1688商品sku
	return request.get(config.baseApi+"/business/DdProduct/alibabaSkuInfo",data)
}
export function submitAlibabaSkuRelative(data){//提交1688商品sku关联
	return request.post(config.baseApi+"/business/DdProduct/subAlibabaSkuRelative",data)
}

/**
 * 线下订单
 */
export function orderServerList(data){//获取我的订单列表
	return request.get(config.baseApi+"/business/OrderServer/list",data)
}
export function orderServerPurchase(data){//采购
	return request.post(config.baseApi+"/business/OrderServer/purchase",data)
}
export function orderServerPurchaseCheckout(data){//采购检出
	return request.post(config.baseApi+"/business/OrderServer/purchase_checkout",data)
}
export function orderServerPurchaseState(data){//刷新采购支付状态
	return request.post(config.baseApi+"/business/OrderServer/purchase_state",data)
}
export function orderServerFilterData(data){
	return request.post(config.baseApi+"/business/OrderServer/filterData",data)
}
export function orderServerCancelPurchase(data){//取消采购
	return request.post(config.baseApi+"/business/OrderServer/cancel_purchase",data)
}
export function orderServerGetOperateInfo(data){//售后操作数据
	return request.get(config.baseApi+"/business/OrderServer/getOperateInfo",data)
}
export function orderServerOpAfterSale(data){//提交售后操作
	return request.post(config.baseApi+"/business/OrderServer/opAfterSale",data)
}


export function transferOrderToPdd(data){//取消采购
	return request.post(config.baseApi+"/business/OrderServer/transfer_order_to_pdd",data)
}
/**
 * 订单管理
 */
export function orderManageList(data){//获取我的订单列表
	return request.get(config.baseApi+"/business/OrderManage/list",data)
}
export function orderManageAddressInfo(data){//查看收货人信息
	return request.get(config.baseApi+"/business/OrderManage/addressInfo",data)
}
export function orderManageShopList(data){//商家店铺列表
	return request.get(config.baseApi+"/business/OrderManage/shopList",data)
}
export function editSyncOrderQueue(data){//商家同步历史订单
	return request.post(config.baseApi+"/business/OrderManage/editSyncOrderQueue",data)
}
export function orderManageDetail(data){//订单详情
	return request.get(config.baseApi+"/business/OrderManage/detail",data)
}
export function orderManageFilterData(data){//获取订单筛选数据
	return request.post(config.baseApi+"/business/OrderManage/filterData",data)
}
export function orderManageBatPurchase(data){//手动批量采购
	return request.post(config.baseApi+"/business/OrderManage/batPurchase",data)
}
export function orderManageCheckAliOrderType(data){//批量采购检出
	return request.post(config.baseApi+"/business/OrderManage/checkAliOrderType",data)
}
export function orderManageBatAbnormal(data){//批量标记异常
	return request.post(config.baseApi+"/business/OrderManage/batAbnormal",data)
}
export function orderManageChangeSku(data){//关联商品
	return request.post(config.baseApi+"/business/OrderManage/changeOrderSku",data)
}
export function orderGetPddSkuInfo(data){//获取拼多多商品sku信息
	return request.get(config.baseApi+"/business/DdProduct/getPddSkuInfo",data)
}

export function orderManageRemarkInfo(data){//订单标记备注信息
	return request.get(config.baseApi+"/business/OrderManage/remarkInfo",data)
}
export function orderManageAddRemark(data){//添加备注和旗子
	return request.post(config.baseApi+"/business/OrderManage/addRemark",data)
}
export function orderManageServiceRemarkInfo(data){//订单客服备注信息
	return request.get(config.baseApi+"/business/OrderManage/serviceRemarkInfo",data)
}
export function orderManageAddServiceRemark(data){//添加客服备注
	return request.post(config.baseApi+"/business/OrderManage/addServiceRemark",data)
}
export function orderManageDeleteProduct(data){//添加客服备注
	return request.post(config.baseApi+"/business/OrderManage/deleteProduct",data)
}
export function orderManageReceipt(data){//确认收货
	return request.post(config.baseApi+"/business/OrderManage/receipt",data)
}
export function orderManageDelPddOrder(data){
	return request.post(config.baseApi+"/business/OrderManage/delPddOrder",data)
}
export function orderManageSendGiftOrder(data){
	return request.post(config.baseApi+"/business/OrderManage/setOrderSendGift",data)
}
export function orderManageSetNotDealOrder(data){
	return request.post(config.baseApi+"/business/OrderManage/setNotDealOrder",data)
}
export function orderManageRepealPurchase(data){
	return request.post(config.baseApi+"/business/OrderManage/repealPurchase",data)
}
export function orderManageNeedSyncPddOrder(data){
	return request.post(config.baseApi+"/business/OrderManage/needSyncPddOrder",data)
}
export function orderManageUpdateOrderAfterSale(data){
	return request.post(config.baseApi+"/business/OrderManage/updateOrderAfterSale",data)
}
export function orderManageCancelDelete(data){
	return request.post(config.baseApi+"/business/OrderManage/cancelDelete",data)
}

export function opDoOrderPay(data){
	return request.post(config.baseApi+"/business/OrderManage/doOrderPay",data)
}
export function ddShopRefreshDecrypt(data){//提额成功更新店铺状态
	return request.get(config.baseApi+"/business/DdShop/refreshDecrypt",data)
}
export function unDecrypt(data){//放弃解密
	return request.get(config.baseApi+"/business/OrderManage/unDecrypt",data)
}
export function reDecrypt(data){//恢复解密
	return request.get(config.baseApi+"/business/OrderManage/reDecrypt",data)
}
export function decrypt(data){//解密单个订单
	return request.get(config.baseApi+"/business/OrderManage/decrypt",data)
}
export function refreshReturnAddress(data){
	return request.post(config.baseApi+"/business/OrderManage/refreshReturnAddress",data)
}
export function setSellerWords(data){
	return request.post(config.baseApi+"/business/OrderManage/setSellerWords",data)
}
export function updatePddAccount(data){
	return request.post(config.baseApi+"/business/OrderManage/updatePddAccount",data)
}
export function updatePddOrderNo(data){
	return request.post(config.baseApi+"/business/OrderManage/updatePddOrderNo",data)
}
export function updateOrderProduct(data){
	return request.post(config.baseApi+"/business/OrderManage/updateOrderProduct",data)
}

export function updateBuyMode(data){
	return request.post(config.baseApi+"/business/OrderManage/updateBuyMode",data)
}

export function baseConfig(data){//系统设置
	return request.get(config.baseApi+"/business/User/baseConfig",data)
}
export function checkPrintRecharge(data){//查询充值打单情况
	return request.post(config.baseApi+"/business/User/checkPrintRecharge",data)
}
export function editPrintProduct(data){//编辑打单商品配置
	return request.post(config.baseApi+"/business/User/editPrintProduct",data)
}
export function businessRoleIndex(data){//岗位管理列表
	return request.post(config.baseApi+"/business/System.Businessrole/index",data)
}
export function businessRoleMenus(data){//权限系统获取菜单
	return request.post(config.baseApi+"/business/System.Businessrole/getRoleMenus",data)
}
export function businessRoleAdd(data){//添加岗位
	return request.post(config.baseApi+"/business/System.Businessrole/add",data)
}
export function businessRoleUpdate(data){//更新岗位设置
	return request.post(config.baseApi+"/business/System.Businessrole/update",data)
}
export function businessRoleDel(data){//删除岗位
	return request.post(config.baseApi+"/business/System.Businessrole/delete",data)
}
export function businessRoleInfo(data){//岗位信息
	return request.post(config.baseApi+"/business/System.Businessrole/getUpdateInfo",data)
}
export function businessRoleExt(data){//岗位禁用状态
	return request.post(config.baseApi+"/business/System.Businessrole/updateExt",data)
}
export function agentuserIndex(data){//员工列表
	return request.post(config.baseApi+"/business/System.Agentuser/index",data)
}
export function agentuserFieldList(data){//获取岗位信息
	return request.post(config.baseApi+"/business/System.Agentuser/getFieldList",data)
}
export function agentuserAdd(data){//添加员工
	return request.post(config.baseApi+"/business/System.Agentuser/add",data)
}
export function agentuserDel(data){//删除员工
	return request.post(config.baseApi+"/business/System.Agentuser/delete",data)
}
export function agentuserInfo(data){//查询员工修改信息
	return request.post(config.baseApi+"/business/System.Agentuser/getUpdateInfo",data)
}
export function agentuserUpdate(data){//更新员工
	return request.post(config.baseApi+"/business/System.Agentuser/update",data)
}
export function agentuserResetPwd(data){//重置密码
	return request.post(config.baseApi+"/business/System.Agentuser/resetPwd",data)
}
export function agentuserExt(data){//修改员工显示状态
	return request.post(config.baseApi+"/business/System.Agentuser/updateExt",data)
}
export function pddAccountList(data){//获取拼多多账号列表
	return request.post(config.baseApi+"/business/PddAccount/list",data)
}
export function checkIsOpenProtocolPay(data){//获取拼多多账号信息
	return request.post(config.baseApi+"/business/PddAccount/checkIsOpenProtocolPay",data)
}
export function pddAccountAdd(data){//添加拼多多账号
	return request.post(config.baseApi+"/business/PddAccount/add",data)
}
export function pddAccountDel(data){//删除拼多多账号
	return request.post(config.baseApi+"/business/PddAccount/delete",data)
}
export function pddAccountUpdate(data){//更新拼多多账号
	return request.post(config.baseApi+"/business/PddAccount/update",data)
}
export function pddAccountDefault(data){//设置拼多多默认账号
	return request.post(config.baseApi+"/business/PddAccount/default",data)
}
export function pddAccountSyncOrder(data){//获取拼多多账号信息
	return request.post(config.baseApi+"/business/PddAccount/syncOrder",data)
}
export function mallCateList(data){//获取拼多多账号信息
	return request.post(config.baseApi+"/business/Mall/cateList",data)
}
export function productRandomEnums(data){
	return request.post(config.baseApi+"/business/ProductRandom/enums",data)
}
export function productRandomList(data){
	return request.post(config.baseApi+"/business/ProductRandom/list",data)
}
export function productRandomDelete(data){
	return request.post(config.baseApi+"/business/ProductRandom/delete",data)
}
export function productRandomAdd(data){
	return request.post(config.baseApi+"/business/ProductRandom/add",data)
}
export function productRandomUpdate(data){
	return request.post(config.baseApi+"/business/ProductRandom/update",data)
}
export function messageSubmit(data){
	return request.post(config.baseApi+"/business/Message/submit",data)
}
export function messageList(data){
	return request.get(config.baseApi+"/business/Message/list",data)
}
export function syncDdProductInfo(data){
	return request.get(config.baseApi+"/business/DdProduct/syncDdProductInfo",data)
}

/**
 * 共享面单
 */
export function shareBillData(data){
	return request.post(config.baseApi+"/business/ShareBill/list",data)
}

export function shareBillUpdateStatus(data){
	return request.post(config.baseApi+"/business/ShareBill/updateStatus",data)
}

export function shareBillDel(data){
	return request.post(config.baseApi+"/business/ShareBill/del",data)
}

export function shareBillCheckBind(data){
	return request.post(config.baseApi+"/business/ShareBill/checkBind",data)
}
export function mywalletCheckPayState(data){
	return request.get(config.baseApi+"/business/Mywallet/checkPayState",data)
}
// 会员相关
export function vipIndex(data){
	return request.get(config.baseApi+"/business/BusinessVip/index",data)
}
export function vipCheckout(data){
	return request.post(config.baseApi+"/business/BusinessVip/checkout",data)
}
export function vipPay(data){
	return request.post(config.baseApi+"/business/BusinessVip/pay_vip",data)
}
export function vipPayState(data){
	return request.get(config.baseApi+"/business/BusinessVip/check_pay_state",data)
}
export function setPddReturnAddress(data){//修改退货地址
	return request.post(config.baseApi+"/business/OrderManage/setPddReturnAddress",data)
}
//店铺会员相关
export function shopVipIndex(data){
	return request.get(config.baseApi+"/business/DdShopVip/index",data)
}
export function shopVipCheckout(data){
	return request.post(config.baseApi+"/business/DdShopVip/checkout",data)
}
export function shopVipPay(data){
	return request.post(config.baseApi+"/business/DdShopVip/pay_vip",data)
}
export function shopVipPayState(data){
	return request.get(config.baseApi+"/business/DdShopVip/check_pay_state",data)
}

export const getWorkOrderList = (data) => {
  return request.post(config.baseApi + '/business/WorkOrder/list', data)
}
export const createWorkOrder = (data) => {
  return request.post(config.baseApi + '/business/WorkOrder/create', data)
}
export const replyWorkOrder = (data) => {
  return request.post(config.baseApi + '/business/WorkOrder/reply', data)
}
export const finishWorkOrder = (data) => {
  return request.post(config.baseApi + '/business/WorkOrder/finish', data)
}
export const getWorkOrderDetail = (data) => {
  return request.post(config.baseApi + '/business/WorkOrder/detail', data)
}
export const getWorkOrderUntreatedTotal = (data) => {
  return request.post(config.baseApi + '/business/WorkOrder/untreated_total', data)
}
export function mallUpdateProductPddGoodsId(data){
	return request.post(config.baseApi+"/business/Mall/updateProductPddGoodsId",data)
}
export function setAutoSendGift(data){
	return request.post(config.baseApi+"/business/Mall/setAutoSendGift",data)
}

export function getStatisticData(data){
	return request.post(config.baseApi+"/business/ShopStatistic/index",data)
}

export function getStatisticRanking(data){
	return request.post(config.baseApi+"/business/ShopStatistic/getRanking",data)
}

export function getStatisticExpressData(data){
	return request.post(config.baseApi+"/business/ShopStatistic/getExpressData",data)
}

export function getStatisticProductDetailData(data){
	return request.post(config.baseApi+"/business/ShopStatistic/product_detail",data)
}

export function getStatisticShopProductRanking(data){
	return request.post(config.baseApi+"/business/ShopStatistic/getShopProductRanking",data)
}

export function getStatisticProductList(data){
	return request.post(config.baseApi+"/business/ShopStatistic/getProductList",data)
}

export function sendAddAlibabaUrl(data){
	return request.post(config.baseApi+"/business/ProductAlibabaUrl/add",data)
}

export function setGiftMoney(data){
	return request.post(config.baseApi+"/business/SetGiftMoney/add",data)
}

export function getGiftMoneyList(data){
	return request.post(config.baseApi+"/business/SetGiftMoney/list",data)
}

export function deleteGiftMoney(data){
	return request.post(config.baseApi+"/business/SetGiftMoney/delete",data)
}

export function getGoodsInfo(data){
	return request.post(config.baseApi+"/business/DdReadyStock/getGoodsInfo",data)
}

export function addStockIn(data){
	return request.post(config.baseApi+"/business/DdReadyStock/addStockIn",data)
}

export function addLinkStockIn(data){
	return request.post(config.baseApi+"/business/DdReadyStock/addLinkStockIn",data)
}

export function getReadyStockList(data){
	return request.post(config.baseApi+"/business/DdReadyStock/list",data)
}

export function bindProductInviteCode(data){
	return request.post(config.baseApi+"/business/Mall/bindProductInviteCode",data)
}
